import { Form, Toolbar } from "devextreme-react";
import { EmptyItem, Label, SimpleItem } from "devextreme-react/form";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  updateClaim,
  updateComment,
  updateCostExclVAT,
  updateDepDate,
  updateStep,
} from "./Redux/IRB";
import { claim } from "../data";
import { Item } from "devextreme-react/toolbar";

const IRBFeeFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function IRBFee(props) {
  const {
    // step, setStep,
    IRBGridRef,
    setIRBPopupVisible,
  } = props;

  const IRB = useSelector((state) => state.IRB);

  const dispatch = useDispatch();

  const onCostExclVATValueChanged = (e) => {
    dispatch(
      updateCostExclVAT({
        costExclVAT: e.value,
      })
    );
  };

  const onDepDateValueChanaged = (e) => {
    dispatch(
      updateDepDate({
        depDate: e.value,
      })
    );
  };

  const onClaimValueChanged = (e) => {
    dispatch(
      updateClaim({
        claim: e.value,
      })
    );
  };

  const onCommentValueChanged = (e) => {
    dispatch(
      updateComment({
        comment: e.value,
      })
    );
  };

  const previousItemOptions = {
    text: "PREVIOUS",
    onClick: () => {
      // setStep(2);
      dispatch(
        updateStep({
          step: 2,
        })
      );
    },
  };

  const saveItemOptions = {
    text: "SAVE",
    onClick: () => {
      if (IRB.action == "insert") {
        IRBGridRef.current.instance
          .getDataSource()
          .store()
          .insert(IRB)
          .then(() => {
            dispatch(
              updateStep({
                step: 0,
              })
            );
            setIRBPopupVisible(false);
            IRBGridRef.current.instance.refresh();
          });
      } else if (IRB.action == "update") {
        const updateValues = {};

        for (const key of IRB.updateFields) {
          if (IRB.hasOwnProperty(key)) {
            updateValues[key] = IRB[key];
          }
        }

        IRBGridRef.current.instance
          .getDataSource()
          .store()
          .update(
            {
              contrNo: IRB.contrNo,
              siteNo: IRB.siteNo,
              SEQ: IRB.SEQ,
            },
            updateValues
          )
          .then(() => {
            dispatch(
              updateStep({
                step: 0,
              })
            );

            setIRBPopupVisible(false);
            IRBGridRef.current.instance.refresh();
          });
      }
    },
  };

  return (
    <IRBFeeFormWrapper>
      <div
        style={{
          margin: "3px auto",
          width: "75vw",
        }}
      >
        <span style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}>
          IRB 심사비
        </span>
        <Form
          id="form-IRBFee"
          colCount={4}
          labelMode="outside"
          labelLocation="top"
          showColonAfterLabel={true}
          style={{
            padding: "16px",
          }}
          validationGroup="IRBFeeData"
        >
          <SimpleItem
            dataField={"costExclVAT"}
            editorType={"dxNumberBox"}
            editorOptions={{
              value: IRB.costExclVAT,
              format: "#,##0",
              inputAttr: {
                style: "text-align: right",
              },
              showClearButton: true,
              onValueChanged: onCostExclVATValueChanged,
            }}
          >
            <Label text={"Cost (Excl.VAT)"} />
          </SimpleItem>
          <SimpleItem
            dataField={"depDate"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: IRB.depDate,
              showClearButton: true,
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              useMaskBehavior: true,
              onValueChanged: onDepDateValueChanaged,
            }}
          >
            <Label text={"입금일"} />
          </SimpleItem>
          <SimpleItem
            dataField={"claim"}
            editorType={"dxSelectBox"}
            editorOptions={{
              dataSource: claim,
              valueExpr: "id",
              displayExpr: "name",
              value: IRB.claim,
              showClearButton: true,
              defaultValue: "N",
              onValueChanged: onClaimValueChanged,
            }}
          >
            <Label text={"청구/미청구"} />
          </SimpleItem>
          <EmptyItem />
          <SimpleItem
            colSpan={4}
            dataField={"comment"}
            editorType={"dxTextBox"}
            editorOptions={{
              value: IRB.comment,
              onValueChanged: onCommentValueChanged,
            }}
          >
            <Label text={"Comment (지급기준 포함)"} />
          </SimpleItem>
        </Form>
        <Toolbar>
          <Item
            location={"before"}
            widget={"dxButton"}
            options={previousItemOptions}
          />
          <Item
            location={"after"}
            widget={"dxButton"}
            options={saveItemOptions}
          />
        </Toolbar>
      </div>
    </IRBFeeFormWrapper>
  );
}
